export const CMR_EXTRACTION_PROGRESS_STEPS = [
  {
    id: 'upload',
    label: 'Uploading document',
    detail: 'Securely transferring your CMR to the extraction engine…',
    minDurationMs: 2200,
  },
  {
    id: 'validate',
    label: 'Validating document',
    detail: 'Checking file format, page count, and readability…',
    minDurationMs: 2800,
  },
  {
    id: 'ocr',
    label: 'Running OCR',
    detail: 'Scanning pages and detecting text regions…',
    minDurationMs: 3200,
  },
  {
    id: 'pan',
    label: 'Identifying PAN',
    detail: 'Locating Permanent Account Number and holder identifiers…',
    minDurationMs: 3000,
  },
  {
    id: 'bank',
    label: 'Extracting bank details',
    detail: 'Reading account number, IFSC, and bank name…',
    minDurationMs: 3200,
  },
  {
    id: 'contact',
    label: 'Extracting contact info',
    detail: 'Parsing email address and date of birth…',
    minDurationMs: 2800,
  },
  {
    id: 'verify',
    label: 'Verifying fields',
    detail: 'Cross-checking extracted values for consistency…',
    minDurationMs: 3500,
  },
  {
    id: 'finalize',
    label: 'Finalizing',
    detail: 'Preparing extracted data for onboarding…',
    minDurationMs: 4000,
  },
];
